export const fetchBrandConfig = async () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                primaryColor: "#1D4ED8", // Example brand primary color (blue)
                secondaryColor: "#FACC15", // Example accent color (yellow)
                textColor: "#FFFFFF", // Default text color
                overlayOpacity: 0.5 // Default overlay opacity
            });
        }, 500); // Simulate network delay
    });
};